export enum ClickAndCollectType {
    noClickCollect = 0,
    clickCollect = 1,
}
